import { useDataProvider, useNotify, useRecordContext, useRefresh } from 'react-admin';

// Every Show-page action (approve / reject / dismiss / remove) is the same POST to
// `/:resource/:id/:subPath`: toast either way, refresh on success. The cause is logged because
// the operator only sees the generic toast. Resolves true on success so a dialog can close.
export const useResourceAction = (
  resource: string,
  subPath: string,
  { success, error }: { success: string; error: string },
) => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  return async (body?: { reason: string }) => {
    try {
      await dataProvider.customMethod(
        resource,
        { id: record?.id, ...body },
        { method: 'POST', subPath },
      );
      notify(success, { type: 'success' });
      refresh();
      return true;
    } catch (cause) {
      console.error(`${resource} ${subPath} failed:`, cause);
      notify(error, { type: 'error' });
      return false;
    }
  };
};
